var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCompanyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 366,
    viewBox: "0 0 366 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 366,
    height: 366,
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.4766,
    y: -31.8164,
    width: 99.6434,
    height: 111.366,
    rx: 8.35939,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2988,
    y: -41.1953,
    width: 99.6434,
    height: 111.366,
    rx: 8.35939,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.318,
    y: 134.25,
    width: 119.199,
    height: 133.222,
    rx: 10,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.48,
    y: 123.031,
    width: 119.199,
    height: 133.222,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.477,
    y: 79.5469,
    width: 49.6434,
    height: 55.4836,
    rx: 4.16474,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.875,
    y: 74.875,
    width: 49.6434,
    height: 55.4836,
    rx: 4.16474,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.498,
    y: 289.449,
    width: 82.4211,
    height: 92.1173,
    rx: 6.91456,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.1426,
    y: 281.691,
    width: 82.4211,
    height: 92.1173,
    rx: 6.91456,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.256,
    y: 227.004,
    width: 87.0786,
    height: 97.3227,
    rx: 7.30529,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.219,
    y: 218.809,
    width: 87.0786,
    height: 97.3227,
    rx: 7.30529,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 366,
    height: 366,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCompanyLogo);
export default __webpack_public_path__ + "static/media/noCompanyLogo.d2fda33b86becef70427251d61dfc86a.svg";
export { ForwardRef as ReactComponent };